import React, { useEffect, useState} from 'react'
import {Dialog, DialogTitle, DialogContent, Select, MenuItem, InputLabel, Button, Skeleton} from '@mui/material'
import { itemServices } from 'src/services/reservation/item/item.service'
import { useTranslate, useRecordContext, useNotify} from 'react-admin'
import SaveIcon from '@mui/icons-material/Save'
import LoadingButton from '@mui/lab/LoadingButton'

export const ChangePaymentStatusDialog = ({open, setOpen, refresh}) => {
    const notify = useNotify()
    const translate = useTranslate()
    const item = useRecordContext()
    const [isLoading, setIsLoading] = useState(false)
    const statusOptions = [
                      /* { id: 'GUARANTEED', name: translate('ra.status.GUARANTEED') }, */
                      { id: 'UNPAID', name: translate('ra.status.UNPAID') },
                      { id: 'PAID', name: translate('ra.status.PAID') },
                      { id: 'PARTIALLY_PAID', name: translate('ra.status.PARTIALLY_PAID') },
                      { id: 'NOT_REQUIRED', name: translate('ra.status.NOT_REQUIRED') },
                      /* { id: 'IN_REVIEW', name: translate('ra.status.IN_REVIEW') }, */
                    ]
    const [selectedStatus, setSelectedStatus] = useState(item.payment_status)


    const onSubmit = async() =>{
        setIsLoading(true)
        await itemServices.update_payment_status_item(selectedStatus, item.hash_).then(()=>{
            setOpen(false)
            refresh()
            notify('ra.message.change_status', {
                type:'success',
                messageArgs:{status:translate(`ra.status.${selectedStatus}`)}
            })
        }).catch(()=>{
            notify('ra.message.update_status_error', {type:'error'})
        }).finally(()=>{
            setIsLoading(false)
        })
    }
  return (
    <div>
        <Dialog
            open = {open}
            onClose={()=>setOpen(false)}
            fullWidth
        >
            <DialogTitle>
                {translate('ra.title.update_status')}
            </DialogTitle>
            <DialogContent>
                <InputLabel id='payment_status'>{translate('ra.field.payment_status')}</InputLabel>
                <Select
                    id='payment_status'
                    fullWidth
                    defaultValue={item.payment_status}
                    size='small'
                    onChange={value=>setSelectedStatus(value.target.value)}
                    /* renderValue={value=>
                        translate(`ra.status.${value}`)
                    } */
                >   
                    {
                        statusOptions.map(option=>(
                            <MenuItem value={option.id} key={option.id}>
                                {option.name}
                            </MenuItem>
                        ))
                    }
                </Select>
            </DialogContent>
            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', margin:'15px'}}>
                <LoadingButton
                    loading={isLoading}
                    variant='contained'
                    startIcon={<SaveIcon />}
                    onClick={onSubmit}
                >
                    {translate('ra.action.save')}
                </LoadingButton>
                <Button onClick={()=>setOpen(false)} variant='outlined' color='error'>
                    {translate('ra.action.cancel')}
                </Button>
            </div>
        </Dialog>
    </div>
  )
}
